import FilterSortOption from '../FilterSortOption';

import type { MiniEventTracker } from '@shared/types/frontend/mini-event-tracker';
import type { SortOption } from '@shared/types/frontend/ubff/hotel-reviews';
import type { I18nService } from '@shared/types/i18n';

import { useHotelReviewsContext } from '@hotels-hotel-detail/data-access/hooks/useHotelReviewsContext';
import DropdownSelector from '@hotels-hotel-detail/ui/DropdownSelector';
import { buildUBFFReviewFilterClicked } from '@hotels-hotel-detail/utils/mini-events/hotels-action';
import { withI18n } from '@shared/ui/contexts/i18n';
import { withMiniEventTracker } from '@shared/ui/contexts/mini-events';
import { ACTION_TYPE } from '@shared/utils-frontend/mini-events/constants';

type Props = {
  i18n: I18nService;
  sorts: SortOption[];
  disabled?: boolean;
  miniEventTracker: MiniEventTracker;
};

const SortByGroup = ({ disabled, i18n, miniEventTracker, sorts }: Props) => {
  const { applySortBy, sortType: selectedSortType } = useHotelReviewsContext();

  const defaultText = i18n.translate('Button_sort');

  const selectedItem = sorts.find(({ type }) => type === selectedSortType);
  const showText = selectedItem ? selectedItem?.displayText : defaultText;
  const sortId = 'sort-dropdown-selector';

  return (
    <DropdownSelector
      id={sortId}
      title={defaultText}
      displayText={showText}
      selected={!!selectedSortType}
      disabled={disabled}
    >
      <>
        {sorts.map(({ displayText, type }, index) => (
          <FilterSortOption
            key={type}
            filterType={sortId}
            checked={
              type === selectedSortType || (!selectedItem && index === 0)
            }
            displayText={displayText}
            value={type}
            onOptionChanged={() => {
              applySortBy(type);
              miniEventTracker.trackHotelsAction(
                ACTION_TYPE.DETAILS_REVIEW_FILTER_CLICKED,
                buildUBFFReviewFilterClicked({
                  type: 'FILTER_TYPE_SORT',
                  value: type,
                }),
              );
            }}
          />
        ))}
      </>
    </DropdownSelector>
  );
};

export default withMiniEventTracker(withI18n(SortByGroup));
